import { Injectable  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsefulToolsService } from '../../../../shared/other/usefultools.service';
import { TripsArry, MethodOfPayment, Account, Vehicle, TripExpenses, Drivers, TripDrivers, TripDriversPostback, CustomerRow } from '../trips-main/trips';
import { SharedService } from 'src/app/shared/shared.service';
import { Observable } from 'rxjs';
// import { Promise } from 'q';

@Injectable ()
export class TripEditService {

  All_MethodOfPayment: MethodOfPayment[];
  All_TabAccount: Account[];
  All_Vehicles: any;
  drivers: any;
  tripDrivers: any;
  trip_Expenses: TripExpenses[];
  dataSource: any;

  constructor(
    private httpclient: HttpClient,
    public sharedservice: SharedService
  ) { }

  async methodOfPayments(ID) {
    return await new Promise(resolve => {
      this.httpclient.get<any>(`${this.sharedservice.URL}/dbMethodOfPayment?SessionID=${sessionStorage.getItem('com-session-id')}&Search=*`).subscribe(Response => {
        this.All_MethodOfPayment = Response.dbMethodOfPayment_response.view;
        this.All_MethodOfPayment.push({Id: 0, Name: ''});
        resolve(this.All_MethodOfPayment);
      });
    });
  }

  async account() {
    return await new Promise(resolve => {
      this.httpclient.get<any>(`${this.sharedservice.URL}/dbTabAccount?SessionID=${sessionStorage.getItem('com-session-id')}&Search=*`).subscribe(Response => {
        console.log('ACC inner');
        console.log(Response);
        this.All_TabAccount = Response.dbTabAccount_response.view;
        this.All_TabAccount.push({ID: 100, NAME: '', email: '', contactNumber: ''});
        resolve(this.All_TabAccount);
      });
    });
  }

  async vehicle() {
    return await new Promise(resolve => {
      this.httpclient.get<any>(`${this.sharedservice.URL}/dbVehicle?SessionID=${sessionStorage.getItem('com-session-id')}&Search=*`).subscribe(Response => {
        this.All_Vehicles = Response.dbVehicle_response.view;
        this.All_Vehicles.forEach(element => {
          element.FULLNAME = element.REGISTRATIONNUMBER + ' - ' + element.MAKE + ' ' + element.MODEL;
        });
        this.All_Vehicles.push({Id: 1000, FULLNAME: ''});
        resolve(this.All_Vehicles);
      });
    });
  }

  async driver(ID) {
    return await new Promise(resolve => {
      this.httpclient.get<any>(`${this.sharedservice.URL}/dbTripDriver?SessionID=${sessionStorage.getItem('com-session-id')}&Search=${ID}`).subscribe(Response => {
        this.drivers = Response.dbTripDriver_response.view;
        resolve(this.drivers);
      });
    });
  }

  async getDrivers() {
    return await new Promise(resolve => {
      this.httpclient.get<any>(`${this.sharedservice.URL}/dbDriver?SessionID=${sessionStorage.getItem('com-session-id')}&Search=*`).subscribe(Response => {
        this.tripDrivers = Response.dbDriver_response.view;
        this.tripDrivers.forEach(element => {
          element.FULLNAME = element.NAME + ' ' + element.SURNAME + ', ' + element.CELLPHONE;
        });
        resolve(this.tripDrivers);
      });
    });
  }

  async tripExspenses(ID) {
    return await new Promise(resolve => {
      this.httpclient.get<any>(`${this.sharedservice.URL}/dbTripExpense?SessionID=${sessionStorage.getItem('com-session-id')}&Search=${ID}`).subscribe(Response => {
        if (Response.dbTripExpense_response.view !== null) {
          this.trip_Expenses = Response.dbTripExpense_response.view;
          resolve(this.trip_Expenses);
        } else {
          this.trip_Expenses = [];
          resolve(this.trip_Expenses);
        }
      });
    });
  }

  async trip(ID) {
    return await new Promise(resolve => {
      this.httpclient.get<any>(`${this.sharedservice.URL}/dbTrip?SessionID=${sessionStorage.getItem('com-session-id')}&Search=${ID}`).subscribe(Response => {
        this.dataSource = Response.dbTrip_response.view[0];
        this.dataSource.DROPOFFDATE = this.dataSource.DROPOFFDATE + ' ' + this.dataSource.DROPOFFTIME;
        this.dataSource.PICKUPDATE = this.dataSource.PICKUPDATE + ' ' + this.dataSource.PICKUPTIME;
        resolve(this.dataSource);
      });
    });
  }

  async driversPostBack(DRV, ID) {
    const driverPostB = [];
    if (DRV !== undefined) {
      DRV.forEach(element1 => {
        if ( element1.hasOwnProperty('__KEY__')) { delete element1['__KEY__']; }
        driverPostB.push({TRIP_ID: ID, DRIVER_ID: element1.DRIVER_ID.toString()});
      });
      const postThis = {SessionID: sessionStorage.getItem('com-session-id'), TripDriver: driverPostB };
      return await new Promise(resolve => {
        this.httpclient.post<any>(`${this.sharedservice.URL}/dbTripDriver`, postThis).subscribe(Response => {
          resolve(Response);
        });
      });
    }
  }


}
